import React from 'react';
import { useSelector } from 'react-redux';
import Actions from '../../actions/actions';
import auth_helper from '../../helpers/auth_helper';

const ImpersonationButton = ({
  userid,
  username,
  name,
  goto,
  url,
  children,
  className,
  customerid = false,
  bySession,
}) => {
  const currUser = useSelector((state) => state.user);

  if (!auth_helper.getCognitoCookie() && currUser.atype !== 'CPF') {
    return <></>;
  }

  return (
    <span
      className={className}
      id="qa-actions-impersonate"
      onClick={(event, data) => {
        event.stopPropagation();
        customerid
          ? Actions.impersonateCustomerOwner({ customerId: customerid, bySession: bySession, goto: goto, url: url })
          : Actions.impersonateUser({ userid, username, name, goto, url });
      }}
    >
      {children}
    </span>
  );
};

export default ImpersonationButton;
